import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import ChartCard from "../ui/Card/ChartCard";
import { CenterRow } from "../ui/Card/Card";
import Donut from "../charts/Donut";
// import Legend from "../ui/Legend/Legend";
import SectionSkeleton from "../ui/SectionSkeleton/SectionSkeleton";
import { INDICATORS, SECTIONS } from "../../constants";
import { fmt1, fmt1Signed, fmtN } from "../../functions/format";
import { pctChange } from "../../functions/mapEffectif";
import { CHART_COLORS } from "../../styles/theme";
import useIndicatorsVisibility from "../../hooks/useIndicatorsVisibility";
import { usePilotageRhStore } from "../../store/usePilotageRhStore";

const { id, title } = SECTIONS.frais;

const SKELETON_ROWS = [{ cols: 3, cards: [5] }];

/** Texte du tooltip "vs précédent" ; ajuster le suffixe ici. */
const formatPctDeltaTip = (current, previous) => {
    if (current === null || current === undefined) return undefined;
    const delta = pctChange(current, previous);
    return delta !== null ? `${fmt1Signed(delta)}% vs précédent` : undefined;
};

const FraisSection = ({ data, isLoading }) => {
    const { isVisible } = useIndicatorsVisibility();
    const compareOn = usePilotageRhStore((s) => !!s.compare[id]);

    if (isLoading && !data) {
        return (
            <Section id={id} title={title}>
                <SectionSkeleton rows={SKELETON_ROWS} />
            </Section>
        );
    }

    if (!data) return null;

    const { categories } = data;

    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                {isVisible(INDICATORS.repartition_categorie) && (
                    <ChartCard
                        indicator={INDICATORS.repartition_categorie}
                        title="Répartition par catégorie"
                    >
                        <CenterRow>
                            <Donut
                                segments={
                                    categories.length && data.total > 0
                                        ? categories.map((c) => ({
                                              value: c.amount,
                                              color: c.color,
                                              tip: `${c.name} : ${fmt1(
                                                  c.amount
                                              )} ${data.devise}`,
                                          }))
                                        : [
                                              {
                                                  value: 1,
                                                  color: CHART_COLORS.line,
                                              },
                                          ]
                                }
                                center={fmtN(data.total)}
                                sub={data.devise}
                                centerTip={
                                    compareOn
                                        ? formatPctDeltaTip(
                                              data.total,
                                              data.totalPrevious
                                          )
                                        : undefined
                                }
                            />
                        </CenterRow>
                        {/* <Legend
                            items={categories.map((c) => ({
                                name: `${c.name} ${fmtN(c.pct)}%`,
                                color: c.color,
                            }))}
                        /> */}
                    </ChartCard>
                )}
            </Grid>
        </Section>
    );
};

export default FraisSection;
